;(function($) {
    $.fn.toJSON = function() {
        var $elements = {};
        var $form = $(this);
        $form.find('input, select, textarea').each(function(){
            var name = $(this).attr('name')
            var type = $(this).attr('type')
            if(name){
                var $value;
                if(type == 'radio'){
                    $value = $('input[name='+name+']:checked', $form).val()
                } else if(type == 'checkbox'){
                    $value = $(this).is(':checked')
                } else {
                    $value = $(this).val()
                }
                $elements[$(this).attr('name')] = $value
            }
        });
        return JSON.stringify( $elements )
    };
    $.fn.fromJSON = function(json_string) {
        var $form = $(this)
        var data = JSON.parse(json_string)
        $.each(data, function(key, value) {
            var $elem = $('[name="'+key+'"]', $form)
            var type = $elem.first().attr('type')
            if(type == 'radio'){
                $('[name="'+key+'"][value="'+value+'"]').prop('checked', true)
            } else if(type == 'checkbox' && (value == true || value == 'true')){
                $('[name="'+key+'"]').prop('checked', true)
            } else {
                $elem.val(value)
            }
        })
    };
}( jQuery ));



;(function(window, $) {
    window.pageContext = window.pageContext || {};
    window.pageContext.components = window.pageContext.components || {};

    window.pageContext.components['advancedSearch'] = {
        init: init
    };

    function init(searchData) {
        var categoryChosenParams = {
            realtyType: {
                disable_search: true,
                width: '100%',
                include_group_label_in_selected: true,
                no_results_text: 'Нет подходящих значений'
            },
            region: {
                disable_search: true,
                width: '100%',
                include_group_label_in_selected: true,
                no_results_text: 'Нет подходящих значений'
            },
            dealType: {
                disable_search: true,
                width: '100%',
                include_group_label_in_selected: true,
                no_results_text: 'Нет подходящих значений'
            }
        };

        Stapes.extend({
            setElement : function($el) {
                this.$el = $el;
            }
        });

        var AdvancedSearchModel = Stapes.subclass({
            cache : {},
            request: function () {
                var self = this;
                console.info('AdvancedSearchModel:request', this.getAll());

                var _data = this.getAll();
                //Object.keys(_data).forEach((key) => (_data[key] == null) && delete _data[key]);
                for(var k in _data) if(!_data[k] || _data[k] == "" || (_data[k]["min"] == "" && _data[k]["max"] == "") ) delete _data[k];

                var _data_str = JSON.stringify(_data);
                console.log("AAAAA");
                console.log(_data_str);

                if ( self.cache[_data_str] ) {
                    self.emit('request.success', self.cache[_data_str]);
                    return;
                }


                $.ajax({
                    type: 'POST',
                    url: '/search/objects-counter/',
                    data: _data,
                    success: function(data){
                        self.cache[_data_str] = data;
                        self.emit('request.success', data);
                    },
                    error: function() {
                        self.emit('request.error');
                    },
                    dataType: 'json'
                });
            }
        });

        var AdvancedSearchView = Stapes.subclass({
            constructor : function($el) {
                var self = this;

                this.data = {
                    searchCount: 0
                };
                this.setElement($el);

                this.advanced = false;
                this.$headerFilters = this.$el.find('.header_filters');
                this.$toggleArea = this.$el.find('#collapseAdvancedSearch');
                this.$searchResults = this.$el.find('.js-header_search-advanced_results');
                this.$searchResultsCount = this.$el.find('.js-search-results-count');
                this.$searchBtn = this.$el.find('.js-show-results-btn');

                this.$el.on('submit', function(e) {
                    if (self.data.searchCount === 0) {
                        e.preventDefault();
                    }
                });


                $('.search-tabs a').click(function() {
                    $('.js-realty-type')
                        .val($(this).attr('href'))
                        .attr("data-id",$(this).attr('data-id'))
                        .attr("data-available-regions",$(this).attr('data-available-regions'))
                        .attr("data-available-deal-types",$(this).attr('data-available-deal-types'))
                        .trigger('change');
                    $('.js-realty-type').trigger('change');
                });

                this.$el.on('click', '.js-expand-trigger', function(e) {
                    self.toggleAdvancedSearch();
                });
            },
            toggleAdvancedSearch: function() {
                this.advanced = !this.advanced;
                this.$toggleArea
                    .toggleClass('collapse', !this.advanced)
                    .toggleClass('collapse.in', this.advanced)
                    .prop('aria-expanded', this.advanced);

                this.$headerFilters.toggleClass('is-adv_shown', this.advanced);

                if (!this.advanced) {
                    this.emit('toggle', this.advanced);
                }
            },
            onSearchSuccess: function(data) {
                console.info('SearchResultsView:onSearchSuccess', data);

                if (typeof (data['result']) !== 'undefined' && data['result']['count'] !== '0') {
                    this.data.searchCount = parseInt(data['result']['count']);
                    $('.search-result-string').show();
                    this.$searchResultsCount.text(this.data.searchCount);
                    this.$searchBtn.removeClass('is-white').addClass('is-red');
                    this.$searchResults.removeClass('not-found').addClass('found');

                if ( data['result']['count'] == 0 ) {
                    $('.not-found-text').show();
                    $('.found-text').hide();
                } else {
                    $('.not-found-text').hide();
                    $('.found-text').show();
                }
                } else {

				$('.not-found-text').show();
				$('.found-text').hide();
                    this.data.searchCount = 0;
                    this.hideSearchResults();
                }
            },
            onSearchError: function() {
                this.hideSearchResults();
            },
            hideSearchResults: function() {
                $('.search-result-string').hide();
                this.$searchResultsCount.text('');
                this.$searchBtn.removeClass('is-red').addClass('is-white');
                this.$searchResults.removeClass('found').addClass('not-found');
            }
        });

        var CategoryView = Stapes.subclass({
            getValue: function() {
                return this.$el.val();
            },
            setValue: function(val) {
                this.$el.val(val);
                this.triggerChange();
            },
            triggerChange: function() {
                this.$el.trigger("chosen:updated");
                this.emit('change', this.getValue());
            }
        });

        var RealtyTypeView = CategoryView.subclass({
            constructor : function($el, chosenParams) {
                var self = this;
                this.setElement($el);

//                this.$el.chosen(chosenParams);


                this.$el.on('change', function() {
                    if (self.$el.val() == 'commercial') {
                        $('.js-commercial-visible').show();
                        $('.js-deal-visible').hide();
                    } else {
                        $('.js-commercial-visible').hide();
                        $('.js-deal-visible').show();
                    }
                    var $selectedOption = self.$el.find('option:selected');
                    console.log("!!!!!!!!!!!!!!!");
                    console.log($selectedOption);

                    if ($selectedOption && $selectedOption.length) {
                        self.emit('change', {
                            value: self.getValue(),
                            dealTypes: $selectedOption.data('availableDealTypes').toString().split(','),
                            regions: $selectedOption.data('availableRegions').toString().split(',')
                        });
                    } else {

                        console.log(self.$el.attr("data-available-deal-types").split(','));

                        self.emit('change', {
                            value: self.$el.val(),
                            dealTypes: self.$el.attr("data-available-deal-types").split(','),
                            regions: self.$el.attr("data-available-regions").split(',')
                        });
                    }
                });
            },
            triggerChange: function() {
                this.$el.trigger("chosen:updated");
                if (this.$el.val() == 'commercial') {
                    $('.js-commercial-selector').show();
                } else {
                    $('.js-commercial-selector').hide();
                }


                var $selectedOption = this.$el.find('option:selected');
                if ( $selectedOption && $selectedOption.length) {
                    this.emit('change', {
                        value: this.getValue(),
                        dealTypes: $selectedOption.data('availableDealTypes').toString().split(','),
                        regions: $selectedOption.data('availableRegions').toString().split(',')
                    });
                } else {
                    this.emit('change', {
                        value: this.$el.val(),
                        dealTypes: this.$el.attr("data-available-deal-types") != undefined ? this.$el.attr("data-available-deal-types").split(',') : '',
                        regions: this.$el.attr("data-available-regions") != undefined ? this.$el.attr("data-available-regions").split(',') : ''
                    });
                };
            }
        });

        var DealTypeView = CategoryView.subclass({
            constructor : function($el, chosenParams) {
                var self = this;
                this.setElement($el);

//                this.$el.chosen(chosenParams);

                this.$el.on('change', function() {
                    self.emit('change', self.getValue());
                });
            },
            updateOptions : function (data) {
                this.$el.parent().find('a').each(function() {
                    var id = $(this).data('id').toString();
                    if(data.indexOf(id) === -1) {
                        $(this).addClass('disabled');
                        //attr('disabled').
                    } else {
                        console.log($(this));
                        $(this).removeClass('disabled');

                    }
                });

                this.triggerChange();
            }
        });

        var RegionView = CategoryView.subclass({
            constructor : function($el, chosenParams) {
                var self = this;
                this.setElement($el);

//                this.$el.chosen(chosenParams);

                this.$el.on('change', function() {
                    self.emit('change', self.getValue());
                });
            },
            updateOptions : function (data) {
                this.$el.find('option').each(function() {
                    var ids = $(this).data('ids').toString().split(',');

                    if(_.isEmpty(_.intersection(data, ids))) {
//                        $(this).hide().prop("selected", false);
                    } else {
//                        $(this).show();
                    }
                });

                this.triggerChange();
            }
        });

        var AdvancedAttributeView = Stapes.subclass({
            constructor : function($el) {
                var self = this;
                this.isVisible = true;
                this.setElement($el);

                this.format = wNumb({
                    mark: '.',
                    thousand: ' ',
                    prefix: '',
                    suffix: ''
                });

                this.$label = this.$el.find('.js-label');
                this.$min = this.$el.find('.js-number[name*=min]');
                this.$max = this.$el.find('.js-number[name*=max]');

                this.$min.number( true, 0, ',', ' ' );
                this.$max.number( true, 0, ',', ' ' );

                this.$min.on('keyup', $.debounce(function(e) {
                    self.onChange(e);
                }, 100));
                this.$max.on('keyup', $.debounce(function(e) {
                    self.onChange(e);
                }, 100));

                this.$min.on('keydown', filterInput);
                this.$max.on('keydown', filterInput);

                function filterInput(e) {
                    var key = e.charCode || e.keyCode || 0;
                    // allow backspace, tab, delete, enter, arrows, numbers and keypad numbers ONLY
                    // home, end, period, and numpad decimal
                    return (
                        key == 8 ||
                        key == 9 ||
                        key == 13 ||
                        key == 46 ||
                        key == 110 ||
                        key == 190 ||
                        (key >= 35 && key <= 40) ||
                        (key >= 48 && key <= 57) ||
                        (key >= 96 && key <= 105)
                    );
                }
            },
            onChange: function() {
                this.emit('change', {min: this.$min.val(), max: this.$max.val()});
            },
            clearInputs: function() {
                this.$min.val("");
                this.$max.val("");
                this.onChange();
            },
            setMin: function(val) {
                if (!this.isVisible) return;

                this.$min.val(val);
                this.onChange();
            },
            setMax: function(val) {
                if (!this.isVisible) return;

                this.$max.val(val);
                this.onChange();
            },
            updatePlaceholders: function(min, max) {
                if (null !== min) {
                    min = parseFloat(min);
                    if (min >= 10000) {
                        min = this.format.to(min);
                    }
                    this.$min.attr('placeholder', min);
                } else {
                    this.$min.attr('placeholder', '');
                }

                if (null !== max) {
                    max = parseFloat(max);
                    if (max >= 10000) {
                        max = this.format.to(max);
                    }
                    this.$max.attr('placeholder', max);
                } else {
                    this.$max.attr('placeholder', '');
                }
            }
        });

        var PriceAttributeView = AdvancedAttributeView.subclass({
            constructor : AdvancedAttributeView.prototype.constructor
        });

        var RoomsAttributeView = AdvancedAttributeView.subclass({
            constructor : AdvancedAttributeView.prototype.constructor,
            updateLabel: function(realtyType) {
                var labels = {
                    'default':     $('#rooms_label_1').val(),
                    'hotels':      $('#rooms_label_2').val(),
                    'restaurants': $('#rooms_label_3').val(),
                    'yachts':      $('#rooms_label_4').val()
                };
8
                this.$label.html(labels.hasOwnProperty(realtyType) ? labels[realtyType] : labels['default']);
            },
            updateVisible: function (realtyType) {
                var hidden = {
                    'default': false,
                    'commercial': false,
                    'salons': true,
                    'stores': true,
                    'barbershops': true
                };

                this.isVisible = !(hidden.hasOwnProperty(realtyType) ? hidden[realtyType] : hidden['default']);
                if (!this.isVisible) {
                    this.clearInputs();
                }

                this.$el.toggleClass('hidden', !this.isVisible);
            }
        });

        var SquareAttributeView = AdvancedAttributeView.subclass({
            constructor : AdvancedAttributeView.prototype.constructor,
            updateVisible: function (realtyType) {
                var hidden = {
                    'default': false,
                    'yachts': true
                };

                this.isVisible = !(hidden.hasOwnProperty(realtyType) ? hidden[realtyType] : hidden['default']);
                if (!this.isVisible) {
                    this.clearInputs();
                }

                this.$el.toggleClass('hidden', !this.isVisible);
            }
        });

        var LengthAttributeView = AdvancedAttributeView.subclass({
            constructor : AdvancedAttributeView.prototype.constructor,
            updateVisible: function (realtyType) {
                var hidden = {
                    'default': true,
                    'yachts': false
                };

                this.isVisible = !(hidden.hasOwnProperty(realtyType) ? hidden[realtyType] : hidden['default']);
                if (!this.isVisible) {
                    this.clearInputs();
                }

                this.$el.toggleClass('hidden', !this.isVisible);
            }
        });

        var AreaAttributeView = AdvancedAttributeView.subclass({
            constructor : AdvancedAttributeView.prototype.constructor,
            updateVisible: function (realtyType) {
                var hidden = {
                    'default': true,
                    'villas': false,
                    'chalet': false,
                    'castles': false,
                    'commercial' : false
                };

                this.isVisible = !(hidden.hasOwnProperty(realtyType) ? hidden[realtyType] : hidden['default']);
                if (!this.isVisible) {
                    this.clearInputs();
                }

                this.$el.toggleClass('hidden', !this.isVisible);
            }
        });

        var TerraceAttributeView = AdvancedAttributeView.subclass({
            constructor : AdvancedAttributeView.prototype.constructor,
            updateVisible: function (realtyType) {
                var hidden = {
                    'default': true,
                    'apartments': false,
                    'new-development': false,

                };

                this.isVisible = !(hidden.hasOwnProperty(realtyType) ? hidden[realtyType] : hidden['default']);
                if (!this.isVisible) {
                    this.clearInputs();
                }

                this.$el.toggleClass('hidden', !this.isVisible);
            }
        });

        var YearAttributeView = AdvancedAttributeView.subclass({
            constructor : AdvancedAttributeView.prototype.constructor,
            updateVisible: function (realtyType) {
                var hidden = {
                    'default': true,
                    'yachts': false
                };

                this.isVisible = !(hidden.hasOwnProperty(realtyType) ? hidden[realtyType] : hidden['default']);
                if (!this.isVisible) {
                    this.clearInputs();
                }

                this.$el.toggleClass('hidden', !this.isVisible);
            }
        });

        var SearchController = Stapes.subclass({
            constructor : function() {
                var self = this;

                this.model = new AdvancedSearchModel();
                this.view = new AdvancedSearchView($('.js-form_search-advanced'));

                this.primaryAttrs = {
                    realtyType: new RealtyTypeView($('.form-el_select.js-realty-type'), categoryChosenParams.realtyType),
                    region: new RegionView($('.form-el_select2.js-regions'), categoryChosenParams.region),
                    dealType: new DealTypeView($('.form-el_select.js-deal-type'), categoryChosenParams.dealType)
                };

                this.advancedAttrs = {
                    price: new PriceAttributeView($('.js-price')),
                    rooms: new RoomsAttributeView($('.js-rooms')),
                    square: new SquareAttributeView($('.js-square')),
                    length: new LengthAttributeView($('.js-length')),
                    area: new AreaAttributeView($('.js-area')),
                    terrace: new TerraceAttributeView($('.js-terrace')),
                    year: new YearAttributeView($('.js-year'))
                };

                this.view.on('toggle', function(data) {
                    console.info('view:toggle', data);
                    $.each(self.advancedAttrs, function(index, value) {
                        value.clearInputs();
                    });
                });

                this.model.on('request.success', function(data) {
                    self.view.onSearchSuccess(data);
                    self.advancedAttrs.price.updatePlaceholders((data['result']['minPrice'] || null), (data['result']['maxPrice'] || null));
                    self.advancedAttrs.rooms.updatePlaceholders((data['result']['minRooms'] || null), (data['result']['maxRooms'] || null));
                    self.advancedAttrs.square.updatePlaceholders((data['result']['minSquare'] || null), (data['result']['maxSquare'] || null));
                    self.advancedAttrs.length.updatePlaceholders((data['result']['minLength'] || null), (data['result']['maxLength'] || null));
                    self.advancedAttrs.area.updatePlaceholders((data['result']['minArea'] || null), (data['result']['maxArea'] || null));
                    self.advancedAttrs.terrace.updatePlaceholders((data['result']['minTerrace'] || null), (data['result']['maxTerrace'] || null));
                    self.advancedAttrs.year.updatePlaceholders((data['result']['minYear'] || null), (data['result']['maxYear'] || null));
                });
                this.model.on('request.error', this.view.onSearchError.bind(this.view));

                this.model.on('change', $.debounce(function() {
                    $.each(self.advancedAttrs, function(index, value) {
                        //value.updatePlaceholders(null, null);
                    });
                    self.model.request();
                }, 50));

                $()

                self.model.set('realtyTypes', $('#commercial-realty-types').val());

                $('#commercial-realty-types').on('change', function() {
                    self.model.set('realtyTypes', $('#commercial-realty-types').val());
                });



                var realtyTypeForms = [];
                var realtyTypePrev = "";

                this.primaryAttrs.realtyType.on('change', function(data) {
                    $('.js-form_search-advanced input').each( function (a,b) {
                        if ( $(b).attr('name') && ( $(b).attr('name').match(/max/g) || $(b).attr('name').match(/min/g) ) ) {
                            $(b).val('');
                        };
                    });

                    /*

                    console.info('realtyType:change', data);

                    console.log("0000000000000");
                    console.log(realtyTypePrev);
                    console.log(realtyTypeForms)
                    realtyTypeForms[realtyTypePrev] = $('.js-form_search-advanced').toJSON();
                    console.log(realtyTypeForms);
                    if ( realtyTypePrev != "" && realtyTypePrev != data.value && realtyTypeForms[data.value] != undefined ) {
                        console.log(111111111111111);
                        console.log(realtyTypeForms[data.value]);
                        $('.js-form_search-advanced').fromJSON(realtyTypeForms[data.value]);
                    } else if ( realtyTypeForms[data.value] == undefined ) {
                        console.log(2222222222222);
                        $('.js-form_search-advanced').fromJSON(realtyTypeForms[""]);
                    }
                    realtyTypePrev = data.value;
                    */


                    if ( data.value == 'castles' ) {
                        $("#region_selector_main").html($("#region_selector_original").html());
                        $('#region_selector_main .js-regions-17').each ( function (a,b) {
                            $(b).remove();
                        });
                        site.set_main_cat_id("wine-regions","region");
                        $('#select2-dropdown li[data-value="wine-regions"]').trigger("click");
                        self.primaryAttrs.region.setValue("wine-regions");
                    } else {
                        $("#region_selector_main").html($("#region_selector_original").html());
                        $('#region_selector_main .js-regions-50').each(function (a, b) {
                            $(b).remove();
                        });
                        site.set_main_cat_id("french-riviera", "region");
                        //$('#region_selector_main option[value="french-riviera"]')
                        $('#select2-dropdown li[data-value="french-riviera"]').trigger("click");
                        self.primaryAttrs.region.setValue("french-riviera");
                    }

                    if ( data.value == 'commercial' ) {
                        site.set_main_cat_id("commercial", "commercial");
                    } else {
                        site.set_main_cat_id("", "commercial");
                    }




                    $(".serch-select-region").select2({allowClear:!0, disabled:false});
                    $(".serch-select-region.is-classic").select2({theme:"classic",allowClear:!0});

                    if (  data.value == 'chalet' ) {
                        self.primaryAttrs.region.setValue("french-alps");
                        $(".serch-select-region").select2({disabled:true});
                    } else if ( data.value == 'yachts' ) {

                        self.primaryAttrs.region.setValue("french-riviera");
                        $(".serch-select-region").select2({disabled:true});
                    }

                    if (  data.value != 'chalet' ) {
                        //remove french-alps
                        $('#region_selector_main .js-regions-18').each(function (a, b) {
                            $(b).remove();
                        });
                    };




                    self.primaryAttrs.dealType.updateOptions(data['dealTypes']);
                    self.primaryAttrs.region.updateOptions(data['regions']);
                    self.model.set('realtyType', data['value']);

                    self.advancedAttrs.rooms.updateLabel(data['value']);
                    self.advancedAttrs.rooms.updateVisible(data['value']);

                    self.advancedAttrs.square.updateVisible(data['value']);
                    self.advancedAttrs.length.updateVisible(data['value']);
                    self.advancedAttrs.area.updateVisible(data['value']);
                    self.advancedAttrs.terrace.updateVisible(data['value']);
                    self.advancedAttrs.year.updateVisible(data['value']);




                });

                this.primaryAttrs.dealType.on('change', function(data) {
                    console.info('dealType:change', data);
                    self.model.set('dealType', data);
                });

                this.primaryAttrs.region.on('change', function(data) {
                    console.info('region:change', data);
                    self.model.set('regions', data);
                });

                this.advancedAttrs.price.on('change', function(data) {
                    console.info('price:change', data);
                    self.model.set('price', data);
                });
                this.advancedAttrs.rooms.on('change', function(data) {
                    console.info('rooms:change', data);
                    self.model.set('rooms', data);
                });
                this.advancedAttrs.square.on('change', function(data) {
                    console.info('square:change', data);
                    self.model.set('square', data);
                });
                this.advancedAttrs.length.on('change', function(data) {
                    console.info('length:change', data);
                    self.model.set('length', data);
                });
                this.advancedAttrs.area.on('change', function(data) {
                    console.info('area:change', data);
                    self.model.set('area', data);
                });
                this.advancedAttrs.terrace.on('change', function(data) {
                    console.info('terrace:change', data);
                    self.model.set('terrace', data);
                });
                this.advancedAttrs.year.on('change', function(data) {
                    console.info('year:change', data);
                    self.model.set('year', data);
                });


                this.primaryAttrs.dealType.setValue("sale");
                this.primaryAttrs.realtyType.setValue("villas");self.model.request();
                this.primaryAttrs.realtyType.setValue("castles");self.model.request();
                this.primaryAttrs.realtyType.setValue("new-development");self.model.request();
                this.primaryAttrs.realtyType.setValue("chalet");self.model.request();
                this.primaryAttrs.realtyType.setValue("castles");self.model.request();
                this.primaryAttrs.realtyType.setValue("commercial");self.model.request();
                this.primaryAttrs.realtyType.setValue("yachts");self.model.request();
                this.primaryAttrs.realtyType.setValue("apartments");self.model.request();


            },
            fillWithData : function(data) {
                if (data['realtyTypeUrl']) this.primaryAttrs.realtyType.setValue(data['realtyTypeUrl']);
                if (data['dealTypeUrl']) this.primaryAttrs.dealType.setValue(data['dealTypeUrl']);
                if (data['regionUrls']) this.primaryAttrs.region.setValue(data['regionUrls']);

                if (data['isAdvanced']) this.view.toggleAdvancedSearch();
console.log("-------------------");
console.log(data);
                if (data['minPrice']) this.advancedAttrs.price.setMin(data['minPrice']);
                if (data['maxPrice']) this.advancedAttrs.price.setMax(data['maxPrice']);
                if (data['minRooms']) this.advancedAttrs.rooms.setMin(data['minRooms']);
                if (data['maxRooms']) this.advancedAttrs.rooms.setMax(data['maxRooms']);
                if (data['minSquare']) this.advancedAttrs.square.setMin(data['minSquare']);
                if (data['maxSquare']) this.advancedAttrs.square.setMax(data['maxSquare']);
                if (data['minArea']) this.advancedAttrs.area.setMin(data['minArea']);
                if (data['maxArea']) this.advancedAttrs.area.setMax(data['maxArea']);
                if (data['minTerrace']) this.advancedAttrs.terrace.setMin(data['minTerrace']);
                if (data['maxTerrace']) this.advancedAttrs.terrace.setMax(data['maxTerrace']);
                if (data['minYear']) this.advancedAttrs.year.setMin(data['minYear']);
                if (data['maxYear']) this.advancedAttrs.year.setMax(data['maxYear']);
                if (data['minLength']) this.advancedAttrs.length.setMin(data['minLength']);
                if (data['maxLength']) this.advancedAttrs.length.setMax(data['maxLength']);
            }
        });

        var controller = new SearchController();
        controller.fillWithData(Object.assign({realtyTypeUrl: 'apartments', dealTypeUrl: 'sale'}, searchData));
    }
})(window, jQuery);
